import Vue from "vue";
import Vuex from "vuex";
import { userLogin, userLogOut, clearNotification, migrateGuestSearchHistory,} from "../../utils/apiFunctions.js";
import {
  setToken,
  setRefreshToken,
  getToken,
  clearCookies,
  getMobileToken,
  getGuestUUID,
  getRefreshToken,
  clearGuestUUID,
} from "../../utils/tokenCheck";
import store from "../index.js";
import { getInfo } from "@/views/TrainingFolder/Dashboard/api-client/dashboard";
import router from "@/router/index.js";
import { COOKIE_OPTIONS_SUFFIX } from "@/utils/cookieConfig.js";
import { appConfig } from "@/config/appConfig.js";

const qs = require("qs");

Vue.use(Vuex);

const state = () => ({
  candAccess: false,
  isPanel: false,
  userData: {
    firstName: "",
    lastName: "",
    email: "",
    image: "",
  },
  token: "",
  refreshToken: "",
  errorMessage: "",
  userDetails: {
    firstName: "",
    lastName: "",
    email: "",
    image: "",
  },
  userCertificateDetails: {},
  selectedAssessment: null,
  userInfo: {},
  profileProgress: null,
  resumeClinicuuid: null,
  resumeJobid: null,
  newUseruuid: null,
  downloadReport: false,
});

const getters = {
  getCandAccess: (state) => state.candAccess,
  getToken: (state) => state.token,
  checkLoginStatus: (state) => state.loggedin,
  getErrorMessage: (state) => state.errorMessage,
  getLoginHeaderFromHeaderVuex: () => store.state.headerVuex.loginHeader,
  getUserDetails: (state) => state.userDetails,
  getUserData: (state) => state.userData,
  getUserInfo: (state) => state.userInfo,
  getUserProfileProgress: (state) => state.profileProgress,
  getCertificateDetails: (state) => state.userCertificateDetails,
  getIsPanel: (state) => state.isPanel,
  getSelectedAssessment: (state) => state.selectedAssessment,
  getResumeuuid: (state) => state.resumeClinicuuid,
  getResumejobid: (state) => state.resumeJobid,
  getNewUseruuid: (state) => state.newUseruuid,
  getDownloadReport: (state) => state.downloadReport,
};
// actions
const actions = {
  async fetchUserData({ commit }) {
    try {
      const response = await getInfo();
      if (response.status === 200) {
        const userData = response.data.data;

        commit("setUserCertificateDetails", userData);
      }
    } catch (error) {
      console.error(error);
    }
  },
  Login({ commit }, userInfo) {
    return new Promise((resolve, reject) => {
      userLogin(userInfo.keycloak, {
        "content-type": "application/x-www-form-urlencoded;charset=utf-8",
      })
        .then(async (response) => {
          const data = response.data;
          if (data.access_token) {
            setToken(data.access_token);
            if (data.refresh_token) {
              setRefreshToken(data.refresh_token);
            }
            commit("SET_TOKEN", data.access_token);
            commit("SET_REFRESH_TOKEN", data.refresh_token);
            const expiry = "Wed, 16 Jan 2030 12:00:00 UTC";
            let project = {
              isActive: true,
              project: "candidate",
              userPermissions: { isActive: true },
            };
            document.cookie = `candidate=${JSON.stringify(
              project,
            )}; ${COOKIE_OPTIONS_SUFFIX}`;
            if (!userInfo.callSetCandAccess) {
              commit("setCandAccess", true);
            }
            try {
              const guestUUID = getGuestUUID();
              if (guestUUID) {
                await migrateGuestSearchHistory(guestUUID);
                clearGuestUUID();
              }
            } catch (error) {
              try {
                clearGuestUUID();
              } catch (e) {
                /* ignore */
              }
            }

            resolve(response);
          } else {
            reject(data);
          }
        })
        .catch((error) => {
          if (error?.response?.data?.error_description)
            commit("SET_ERROR_MESSAGE", error.response.data.error_description);
          reject(error);
        });
    });
  },

  //SaveAccess Implemented from Candidate

  // async saveAccess({ commit }, data) {
  //   const { details, flag, loginData } = data;

  //   // Build cookie expiry
  //   const expiry = "Wed, 16 Jan 2030 12:00:00 UTC";
  //   const domain = "simplifymycareer.com";

  //   // Core projects to check against
  //   const coreProjects = [
  //     "recruitment",
  //     "assessment",
  //     "candidate",
  //     "training",
  //     "collegeDashboard",
  //   ];

  //   // Set 'no-access' cookie for any core project NOT present in the details array
  //   coreProjects.forEach((projName) => {
  //     const hasProject = details.some((p) => p.project === projName);
  //     if (!hasProject) {
  //       document.cookie = `${projName}=no-access;expires=${expiry};path=/;domain=${domain};`;
  //     }
  //   });

  //   // Save each active project as a cookie
  //   details.forEach((project) => {
  //     document.cookie = `${project.project}=${JSON.stringify(
  //       project,
  //     )};expires=${expiry};path=/;`;
  //   });

  //   // Save loginData cookie
  //   document.cookie = `loginData=${JSON.stringify(
  //     loginData,
  //   )};expires=${expiry};path=/;domain=${domain};`;
  //   // document.cookie = `loginData=${JSON.stringify(loginData)};expires=${expiry};path=/;domain=${domain};`;

  //   // Try fetching preferences if this is an admin login
  //   const redirectFlag = loginData.type || flag;
  //   let finalRedirectFlag = redirectFlag;

  //   if (redirectFlag !== "candidate") {
  //     try {
  //       console.log("Fetching user preference...");
  //       const prefRes = await getPreference();
  //       if (
  //         prefRes &&
  //         prefRes.status === 200 &&
  //         prefRes.data &&
  //         prefRes.data.data
  //       ) {
  //         const prefData = prefRes.data.data;
  //         console.log("Preffered Project: ", prefData.defaultModule);
  //         commit("setPreference", prefData);
  //         if (
  //           prefData.defaultModule &&
  //           prefData.defaultModule !== "candidate"
  //         ) {
  //           finalRedirectFlag = prefData.defaultModule;
  //         }
  //       }

  //       console.log(prefRes.data);
  //     } catch (e) {
  //       console.error("Failed to fetch user preference", e);
  //     }
  //   }

  //   // If it's an admin login and no preference was found, find the first project
  //   // they have access to (other than candidate).
  //   if (finalRedirectFlag === "admin" && details && details.length > 0) {
  //     const activeProjects = details.filter((p) => {
  //       return p.userPermissions ? p.userPermissions.isActive : p.isActive;
  //     });
  //     // Try to find any project besides candidate
  //     const defaultProject = activeProjects.find(
  //       (p) => p.project !== "candidate",
  //     );
  //     if (defaultProject) {
  //       finalRedirectFlag = defaultProject.project;
  //     }
  //   }
  //   // Redirect based on flag
  //   const projectUrls = {
  //     recruitment: "https://recruitment.simplifymycareer.com/",
  //     assessment: "https://judge.simplifymycareer.com/",
  //     candidate: "https://candidate.simplifymycareer.com?from=candidate",
  //     training: "https://trainingadmin.simplifymycareer.com/",
  //     collegeDashboard: "https://college.simplifymycareer.com/",
  //   };

  //   let url = projectUrls[finalRedirectFlag];
  //     // window.location.replace(url);
  // },

  LogOut({ commit }) {
    const redirectUrl = getMobileToken() ?  `${appConfig.candidateBase}/login` : appConfig.websiteBase;
    userLogOut(
      qs.stringify({
        client_id: getMobileToken() ? "hire3x-app" : "vue-test-app",
        refresh_token: getRefreshToken(),
      }),
      {
        "content-type": "application/x-www-form-urlencoded;charset=utf-8",
        Authorization: `Bearer ${getToken()}`,
      }
    )
      .then(async (response) => {
        if(getMobileToken()) {
          try {
            await clearNotification({token: getMobileToken()});
          } catch (error) {
            console.log("Error clearing notification:", error);
          }
        }
        commit("SET_TOKEN", "");
        commit("SET_REFRESH_TOKEN", "");
        localStorage.clear();
        clearCookies();
        // location.replace("http://localhost:8080/login");
        window.location.replace(redirectUrl);
        return response;
        // alert("User Logged Out");
      })
      .catch(async (error) => {
        if(getMobileToken()) 
          try {
            await clearNotification({token: getMobileToken()});
          } catch (error) {
            console.log("Error clearing notification:", error);
          }
        commit("SET_TOKEN", "");
        commit("SET_REFRESH_TOKEN", "");
        localStorage.clear();
        clearCookies();
        // location.replace("http://localhost:8080/login");
        window.location.replace(redirectUrl);
        console.log(error);
      });
  },
};
// mutations
const mutations = {
  setNewUseruuid(state, uuid) {
    state.newUseruuid = uuid;
  },
  setresumeJobid(state, jobId) {
    state.resumeJobid = jobId;
  },
  setresumeClinicuid(state, uuid) {
    state.resumeClinicuuid = uuid;
  },
  setDownloadReport(state, payload) {
    state.downloadReport = payload;
  },
  setCandAccess(state, payload) {
    state.candAccess = payload;
  },
  setUserInfo(state, payload) {
    state.userInfo = payload;
  },
  setUserProfileProgress(state, progress) {
    state.profileProgress = progress;
  },

  setUserCertificateDetails(state, payload) {
    state.userCertificateDetails = payload;
  },
  setUserData(state, payload) {
    console.log(payload);
    state.userData = payload;
    console.log("user", state.userData);
  },
  checkLoginStatus(state, payload) {
    state.loggedin = payload;
  },
  SET_TOKEN(state, token) {
    state.token = token;
  },
  SET_REFRESH_TOKEN(state, refreshToken) {
    state.refreshToken = refreshToken;
  },
  SET_ERROR_MESSAGE(state, errorMessage) {
    state.errorMessage = errorMessage;
  },
  SET_USER_DETAILS(state, userDetails) {
    state.userDetails = userDetails;
  },
  SET_IS_PANEL(state, isPanel) {
    state.isPanel = isPanel;
  },
  SET_SELECTED_ASSESSMENT(state, assessment) {
    state.selectedAssessment = assessment;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
